import { Component, OnInit, Input } from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'conclusion',
  templateUrl: './conclusion.component.html',
  styleUrls: ['./conclusion.component.css']
})
export class ConclusionComponent implements OnInit {

  constructor(private router:Router) { }

  ngOnInit(): void {
  }

  back() {
    localStorage.setItem("reportSent", JSON.stringify(3));
	location.href = "https://www.dbs.com.sg/sme/sustainability";
  }
}
